__turbopack_context__.v({
  "bulletDisclaimer": "ModalitySection-module__D2h6IW__bulletDisclaimer",
});
